import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/ds160')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/admin/ds160"!</div>
}
